import { useEditorContext } from "../EditorContext";
import FormLabel from "../FormCommonField/FormLabel";
import { getBorderStyleObj } from "../FormText/FormBaseStyle";
import { toRGBA } from "../parser/utils";
import DownArrowIcon from "../SideContent/DownArrowIcon";

export default ({ data }) => {
  const {
    placeholder,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    labelFontColor,
    labelDefaultFont,
    labelFontSize,
    labelHorizonAlignment,
  } = data;

  const { state } = useEditorContext();
  const borderStyleObj = getBorderStyleObj(state.root.data);
  const { formTextColor } = state.root.data;
  const customLabelStyle = {
    color: toRGBA(labelFontColor || formTextColor),
    fontFamily: labelDefaultFont,
    fontSize: labelFontSize,
    justifyContent: labelHorizonAlignment || "start",
  };
  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "left",
      }}
    >
      <FormLabel data={data} customLabelStyle={customLabelStyle} />
      <div
        style={{
          height: 38,
          display: "flex",
          position: "relative",
          alignItems: "center",
          ...borderStyleObj,
        }}
      >
        <div
          style={{
            padding: "0 8px",
            color: "#707070",
          }}
        >
          {placeholder}
          <div style={{ position: "absolute", right: 10, width: 16, top: 10 }}>
            <DownArrowIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
